<template>
  <app-main>
    <app-header  slot="header" color="is-default" :is_display_down="false"></app-header>
    <div class="box">
      <div class="mediaAudio" @click="music()" :style="{'animation-play-state':animationShow}">
        <audio
          autoplay="autoplay"
          id="bg-music"
          loop
          ref="MusicPlay"
          class="mediaAudio"
          src="https://res.jaadee.net/active/video/mqjh5bg.mp3"
        ></audio>
      </div>
      <div class="swiper">
        <div class="swiper-container" ref="mySwiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(value, index) in banners" :key="value.id">
              <img :src="bg[index].imgurl" style="width:100%;height:100%" alt />
              <img
                class="ani animate imgbg"
                :swiper-animate-effect="effect[index]"
                swiper-animate-duration="1.5s"
                swiper-animate-delay="0s"
                :src="value.imgurl"
              />
              <img v-show="index===7" :src="bg[index+1].imgurl" class="go" @click="go()" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-main>
</template>
<script>
import Vue from "vue";
import AppMain from '../layouts/Main';
import AppHeader from '../layouts/Header';
import VueAwesomeSwiper from "vue-awesome-swiper";
import config, { inApp, isTest } from "../../config";
import "swiper/css/swiper.css";
import { swiper, swiperSlide, directive } from "vue-awesome-swiper";
import animate from 'animate.css'
import * as swiperAni from '../../assets/js/swiper.animate.min.js'
import { goWebview, globalNavigate } from "../../RNApp";
Vue.use(VueAwesomeSwiper);
Vue.use(animate)
export default {
  name: "mum",
  components: {
    swiper,
    swiperSlide,
    AppMain,
    AppHeader
  },
  props: {
    vaule: {
      type: Object,
    }
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      banners: [
        { imgurl: require("../../assets/images/active/1text.png") },
        { imgurl: require("../../assets/images/active/2text.png") },
        { imgurl: require("../../assets/images/active/3text.png") },
        { imgurl: require("../../assets/images/active/4text.png") },
        { imgurl: require("../../assets/images/active/5text.png") },
        { imgurl: require("../../assets/images/active/6text.png") },
        { imgurl: require("../../assets/images/active/7text.png") },
        { imgurl: require("../../assets/images/active/8text.png") },
      ],
      bg: [
        { imgurl: require("../../assets/images/active/1.jpg") },
        { imgurl: require("../../assets/images/active/2.jpg") },
        { imgurl: require("../../assets/images/active/3.jpg") },
        { imgurl: require("../../assets/images/active/4.jpg") },
        { imgurl: require("../../assets/images/active/5.jpg") },
        { imgurl: require("../../assets/images/active/6.jpg") },
        { imgurl: require("../../assets/images/active/7.jpg") },
        { imgurl: require("../../assets/images/active/8.jpg") },
        { imgurl: require("../../assets/images/active/go.png") },
      ],
      num: '',
      effect: [
        "flash",
        "bounceIn",
        "bounceInLeft",
        "bounceInUp",
        "fadeInDown",
        "fadeInRight",
        "flipInY",
        "flipInX",
      ],
      isPlay: true,
      animationShow: 'running',
      remove: false,
    };
  },
  created() {
  },
  computed: {

  },
  mounted() {
    let that = this;
    this.swiper = new Swiper(".swiper-container", {
      direction: 'vertical',
      autoplay: false,
      autoHeight: true,
      height: window.innerHeight,
      initialSlide: 0,
      autoplayDisableOnInteraction: false,
      loop: false,
      paginationClickable: true,
      observer: true,
      observeParents: true,
      effect: 'fade',
      onInit: function (swiper) {
        swiperAni.swiperAnimateCache(swiper); //隐藏动画元素 
        swiperAni.swiperAnimate(swiper); //初始化完成开始动画
      },
      onSlideChangeEnd: function (swiper) {
        swiperAni.swiperAnimate(swiper); //每个slide切换结束时也运行当前slide动画
      },
    });
    document.body.addEventListener('touchstart', that.musicPlay, true);
  },
  methods: {
    removes() {
      let that = this
      document.body.removeEventListener('touchstart', that.musicPlay, true);
    },
    musicPlay() {
      let that = this
      var media = document.querySelector('#bg-music')
      media.load();
      let playPromise = media.play();
      if (playPromise !== undefined) {
        playPromise.then(() => {
          media.play();
          that.isPlay = false
          that.animationShow = 'running'
          that.removes()
        }).catch(() => { })
      }
    },
    music() {
      let that = this
      if (that.isPlay) {
        that.$refs.MusicPlay.pause()
        that.isPlay = false
        that.animationShow = 'paused'
      } else {
        that.$refs.MusicPlay.play();
        that.isPlay = true
        that.animationShow = 'running'
      }
    },
    go() {
      this.$JD.router({
        url: "https://app.jaadee.com/topic/m/142",
        isHttps: true,
        isShowTitle: true,
        title: "母亲节活动",
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.box {
  height: 100%;
  @keyframes changDeg {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .mediaAudio {
    position: fixed;
    bottom: 0.4rem;
    right: 0;
    width: 0.5rem;
    height: 0.5rem;
    z-index: 99;
    background: url("../../assets/images/active/music.png");
    background-size: cover;
    animation: changDeg 2s linear 0.2s infinite;
  }
  .swiper {
    height: 100%;
    background-size: cover;
    .swiper-wrapper {
      height: 100%;
      width: 100%;
      .swiper-slide {
        height: 100%;
        .imgbg {
          position: fixed;
          top: 0;
          left: 0;
        }
        img {
          // width: 100%;
          height: 100%;
        }
        .go {
          position: fixed;
          bottom: 0.45rem;
          left: 1.3rem;
          width: 2.4rem;
          height: 0.6rem;
        }
      }
    }
    .swiper-pagination {
      bottom: 0.3rem !important ;
      /deep/.swiper-pagination-bullet {
        width: 0.04rem;
        height: 0.04rem;
        background: #666666;
      }
      /deep/ .swiper-pagination-bullet-active {
        background-color: #fff;
      }
    }
  }
}
</style>